import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { extractGlobalId, getGroupId, getScheduleId } from "library/get-unique-id-from-tree"
import { getTreeId } from "library/id-helpers"
import { getPublishedPlan } from "routes/plan/controller/publish-plan"

export function useTailoringReferenceId() {
    const { currentId } = useBoundContext()

    const regimeId = getTreeId(currentId)
    const groupId = getGroupId(currentId)
    const scheduleId = getScheduleId(extractGlobalId(currentId))

    const data = getPublishedPlan.useResults(regimeId, "")

    const regimeVersion = (data?.tree?.version || 0) + 1
    const referenceId = `${regimeId}-version:${regimeVersion}.${groupId}!${scheduleId}`

    return { referenceId, regimeVersion }
}
